import type { ComicCategory } from "../types/comic";

export const comicCategories: ComicCategory[] = [
  {
    id: "rexue",
    name: "热血",
    icon: "ri-fire-line",
    description: "燃烧热血与梦想，少年向战斗漫画集中地，越挫越勇的高燃剧情。",
  },
  {
    id: "lianai",
    name: "恋爱",
    icon: "ri-heart-3-line",
    description: "心动瞬间与青春悸动，从校园到都市的甜蜜与酸涩恋爱物语。",
  },
  {
    id: "xuanhuan",
    name: "玄幻",
    icon: "ri-magic-line",
    description: "仙界妖界与异能力量的宏大世界，冒险、修行与宿命交织的奇幻篇章。",
  },
  {
    id: "kehuan",
    name: "科幻",
    icon: "ri-rocket-2-line",
    description: "星海、机甲与未来科技，探索未知宇宙与人类未来的想象边界。",
  },
  {
    id: "xuanyi",
    name: "悬疑",
    icon: "ri-eye-line",
    description: "层层反转与暗线推理，跟随主角揭开都市背后的神秘真相。",
  },
  {
    id: "zhiyu",
    name: "治愈",
    icon: "ri-cup-line",
    description: "温暖日常与柔软小事，治愈疲惫心灵的生活系作品。",
  },
  {
    id: "xiaoyuan",
    name: "校园",
    icon: "ri-graduation-cap-line",
    description: "社团、教室与操场，记录青春校园里的欢笑与成长。",
  },
  {
    id: "gufeng",
    name: "古风",
    icon: "ri-book-2-line",
    description: "江湖剑影与古韵山河，笔墨之间再现古典东方的浪漫与侠义。",
  },
];